import { DigitalMarketplaceFrontendComponent } from '../../digitalmarketplace-frontend-component'

class SearchBox implements DigitalMarketplaceFrontendComponent {
  static moduleName = 'dm-search-box'

  $module: JQuery<HTMLElement>
  $toggleTarget: JQuery<HTMLElement>

  constructor ($module: JQuery<HTMLElement>) {
    this.$module = $module
    this.$toggleTarget = this.$module.find('.js-class-toggle')
  }

  init () {
    if (!this.inputIsEmpty()) {
      this.addFocusClass()
    }
  
    this.$toggleTarget.on('focus', this.addFocusClass.bind(this))
    this.$toggleTarget.on('blur', this.removeFocusClassFromEmptyInput.bind(this))
  }

  inputIsEmpty () {
    return this.$toggleTarget.val() === ''
  }

  addFocusClass () {
    this.$toggleTarget.addClass('focus')
  }

  removeFocusClassFromEmptyInput () {
    if (this.inputIsEmpty()) {
      this.$toggleTarget.removeClass('focus')
    }
  }
}

export { SearchBox }
